import React  from 'react'
import styled from 'styled-components'
import { FieldWrapper } from '@progress/kendo-react-form'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import { Label } from '@progress/kendo-react-labels'

export default (fieldRenderProps) => {
    const { label, valid, disabled, data, ...others } = fieldRenderProps
    return <FieldWrapper>
        <StyledLabel editorValid={valid} editorDisabled={disabled}>{label}</StyledLabel>
        <DropDownList data={data} textField="title" dataItemKey="id"  {...others}/>
    </FieldWrapper>
}

const StyledLabel = styled(Label)`
    font-size: 12px;
    color: rgba(0,0,0,0.6);
    display: block;
    padding-top: 4px;
`



// WEBPACK FOOTER //
// ./src/components/common/DropDownField.js